var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[(_vm.isActive)?_c('div',{staticClass:"notification",class:{
            'is-danger': _vm.isDanger,
            'is-success': _vm.isSuccess,
            'is-warning': _vm.isInfo,
        }},[(_vm.persistant == false)?_c('button',{staticClass:"delete",on:{"click":_vm.close}}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }